import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import './index.css';
import { Toaster } from 'react-hot-toast';
import App from './App';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Toaster
          position="top-center"
          reverseOrder={false}
          gutter={8}
          toastOptions={{
            duration: 5000,
            success: {
              style: {
                background: '#b0c4de',
                color: '#fff',
              },
            },
            error: {
              style: {
                background: '#e2725b',
                color: '#fff',
              },
            },
          }}
        />
        <App />
      </QueryClientProvider>
      {/* <ReactQueryDevtools initialIsOpen /> */}
    </BrowserRouter>
  </React.StrictMode>,
);
